import React, { useEffect, useContext } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { LayoutContext } from "App/common/hoc/Layout";
import { cancelAccountResetState } from "store/actions";

function CancelAccountConfirmation(props) {
  const { lState, lMethods } = useContext(LayoutContext);
  const lStateRef = React.useRef();

  /*****************************Handling  popup using enter key ***************************/
  useEffect(() => {
    lStateRef.current = lState;
    const handleKeyDown = e => {
      if (
        e.key === "Enter" &&
        lStateRef.current.popup.show &&
        lStateRef.current.popup.alertName === "CancelAccountConfirmation"
      ) {
        lMethods.closePopup();
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    // Cleanup: Remove the event listener when the component unmounts
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [lState]);

  useEffect(() => {
    if (props.cancelAccount.error.show)
      lMethods.openPopup("cancelAccount", {
        execute: null,
        details: props.cancelAccount.details
      });

    lMethods.updatePopupParams({
      loading: props.cancelAccount.loading,
      error: props.cancelAccount.error
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.cancelAccount]);

  return (
    <div className="popup_body_scrollbar">
      <div className="deletion_form-2">
        <div className="cancellation_account_body_inner">
          <div className="cancellation_account_msg_image" />
          <p>
            On cancelling your IDrive Mirror account, all of your files will be
            permanently deleted. Your files will no longer be protected by
            IDrive Mirror and they may be prone to data loss.
          </p>
          <p>We highly recommend that you continue using IDrive Mirror.</p>
        </div>
      </div>
    </div>
  );
}

function mapStateToProps(state) {
  return {
    cancelAccount: state.account.cancelAccount
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ cancelAccountResetState }, dispatch);
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CancelAccountConfirmation);
